"use client";
import useProfile, { AuthStatus } from "@app/lib/profile/state";
export default function ProfileInitialiser() {
    const authStatus = useProfile((state) => state.authStatus);
    const checkUserSession = useProfile((state) => state.checkUserSession);
  
    if(authStatus !== AuthStatus.AUTHENTICATED) {
        checkUserSession();
    }

    return null;
}
